import { createContext, useContext } from 'react'

import type { OpenAPIV3_1 as OpenApi } from 'openapi-types'

import type { getRefValue } from './getRefValue'

export type ApiContext = {
	components: Required<Pick<OpenApi.ComponentsObject, 'schemas' | 'parameters' | 'headers' | 'responses'>>
	getRefValue: (ref: string) => ReturnType<typeof getRefValue>
}

const apiContext = createContext<ApiContext | undefined>(undefined)

export const useApiContext = () => {
	const value = useContext(apiContext)

	if (!value) throw new Error('Cannot useApiContext without provider')

	return value
}

export const ApiContextProvider = apiContext.Provider
